/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_Board_Outstanding_Sub_OneInputs */



/**
* | output |
* | --- |
* | "No invoice created yet · 1 partner" |
*
* @param {Partner_Billing_Board_Outstanding_Sub_OneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_outstanding_sub_one = /** @type {((inputs?: Partner_Billing_Board_Outstanding_Sub_OneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Outstanding_Sub_OneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch keine Rechnung erstellt · 1 Partner")
	return /** @type {LocalizedString} */ ("No invoice created yet · 1 partner")
});